import { render } from "./Work.vue?vue&type=template&id=619a5220&scoped=true"
const script = {}

import "./Work.vue?vue&type=style&index=0&id=619a5220&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-619a5220"

export default script